import { ActionButton } from 'elements/minute/sidebar/sidebarComponents/atomic/ActionButton';
import { NumberValue } from 'elements/minute/sidebar/sidebarComponents/atomic/NumberValue';
import { LocationSearchInput } from 'elements/minute/sidebar/sidebarComponents/complex/LocationSearchInput';
import { useSelectMapPosition } from 'hooks/map/useSelectMapPosition';
import { EWorldAction } from 'libs/utils/world/worldTypes';
import { useContext, useEffect, useState } from 'react';
import { ICoordinates } from 'react-give-me-map';
import { CtxEdit } from 'session/ctxEdit';
import styled from 'styled-components/macro';
import { useUpdateEffect } from 'usehooks-ts';

interface Props {
    coordinate: ICoordinates;
    onChange: (coordinate: ICoordinates) => void;
    className?: string;
}

export const LocationPickerButton = (props: Props) => {
    const ctxEdit = useContext(CtxEdit);
    const mapRef = ctxEdit.mapRef.current;

    const [coordinate, setCoordinate] = useState(props.coordinate ?? { lat: null, lng: null });

    useUpdateEffect(() => {
        if (coordinate.lat && coordinate.lng) {
            props.onChange(coordinate);
        }
    }, [coordinate]);

    useUpdateEffect(() => {
        const newCoordinate = props.coordinate;
        if (newCoordinate.lat !== coordinate.lat || newCoordinate.lng !== coordinate.lng) {
            setCoordinate({ lat: newCoordinate.lat, lng: newCoordinate.lng });
        }
    }, [props.coordinate.lat, props.coordinate.lng]);

    const { isSelectActive, setIsSelectActive } = useSelectMapPosition({
        mapRef,
        onCoordinateSelected: (coordinate) => {
            setCoordinate(coordinate);
        }
    });

    useEffect(() => {
        const newAction = isSelectActive ? EWorldAction.POINT_SELECT : EWorldAction.SELECT;
        ctxEdit.setWorldAction(newAction);
    }, [isSelectActive]);

    return (
        <S_LocationPickerButton className={props.className}>
            <S_Col1>
                {!isSelectActive && (
                    <>
                        <S_NumberValue1
                            value={coordinate.lat}
                            onChange={(lat) => setCoordinate((curr) => ({ ...curr, lat }))}
                        />
                        <S_NumberValue2
                            value={coordinate.lng}
                            onChange={(lng) => setCoordinate((curr) => ({ ...curr, lng }))}
                        />
                    </>
                )}
                {isSelectActive && (
                    <>
                        <LocationSearchInput
                            onLocationSelected={({ lat, lng }) => {
                                setCoordinate({ lat, lng });
                                setIsSelectActive(false);
                            }}
                        />
                    </>
                )}
            </S_Col1>
            <S_Col2>
                <ActionButton
                    icon={{ iconSet: 'far', iconName: 'crosshairs' }}
                    highlighted={isSelectActive}
                    onClick={() => {
                        setIsSelectActive(!isSelectActive);
                    }}
                />
            </S_Col2>
        </S_LocationPickerButton>
    );
};

const S_LocationPickerButton = styled.div`
    display: flex;
`;

const S_Col1 = styled.div`
    display: flex;
    flex-direction: row;
    margin: 0 10px 0 0;
    width: 150px;
`;

const S_Col2 = styled.div`
    display: flex;
    flex-direction: column;
`;

const S_NumberValue1 = styled(NumberValue)`
    margin: 0 10px 0 0;
`;

const S_NumberValue2 = styled(NumberValue)``;
